import React from 'react'
import {connect} from "react-redux"

const centerStyle = {
  zIndex: 451,
  position: 'fixed',
  top: '50%',
  left: '50%',
  marginLeft: -20,
  marginTop: -20
}

export class LoadingModal extends React.Component {

  getLoadingImage() {
    return this.props.isMocEnabled ?
        (<img src="images/loading-moc.gif" style={{height: 80}}/>) :
        (<img src="images/loading2.gif" style={{height: 40}}/>)
  }

  render() {
    return (this.props.loadingCount) ? (
            <div className="waiting-modal-effect">
              <div style={centerStyle}>
                {!this.props.suppressLoadingGif && this.getLoadingImage()}
              </div>
            </div>
        )
        : null
  }
}

function mapStateToProps(state) {
  return {
    loadingCount: state.app.loadingCount,
    suppressLoadingGif: state.app.suppressLoadingGif,
    isMocEnabled: state.app.isMocEnabled,
  }
}

export default connect(mapStateToProps)(LoadingModal)